import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import 'aos/dist/aos.css';
import '@vueform/slider/themes/default.css';
import "vue-toastification/dist/index.css";
import VueCookies from 'vue3-cookies'
import VueLazyLoad from 'vue3-lazyload'
import Toast from "vue-toastification";
import { createMetaManager } from 'vue-meta'

require("@/assets/main.scss");

const filterBeforeCreate = (toast, toasts) => {
    if (toasts.filter(t => t.type === toast.type).length !== 0) {
      return false;
    }
    return toast;
}

const app = createApp(App);
app.use(store);
app.use(router);
app.use(VueCookies);
app.use(VueLazyLoad);
app.use(Toast, {
    position: "bottom-right",
    timeout: 2500,
    closeOnClick: true,
    maxToasts: 2,
    filterBeforeCreate 
});
app.use(createMetaManager());
app.mount("#app");

app.mixin({
    methods: {
        speechSynthesis(text) {
            speechSynthesis.cancel();
            let textSynthesizer = new SpeechSynthesisUtterance(text);
            speechSynthesis.speak(textSynthesizer);
        }
    },
})
